const LEGACY_GTM_ID = "GTM-KNF6F52M";

export function getGoogleTagManagerId(): string {
    // Keep unconfigured deployments on their existing container until the vendor audit.
    // Use the same selection for the browser script and the no-JavaScript iframe.
    return process.env["NEXT_PUBLIC_GTM_ID"] || LEGACY_GTM_ID;
}
